import { Action, createAction, handleActions } from "redux-actions";
import type { FieldChangeEvent } from "~business/Cards/types";
import {
  aCampoFecha,
  aCampoSiniestro,
  CampoFecha,
  CampoSiniestro,
  CargaSiniestroData,
  CargaSiniestroState,
  Dispatch,
  GetPolizasCriteria,
  GetState,
  OpcionSiniestro,
  PolizasBuscadas,
  PolizaVinculada,
  ServicesCargaSiniestro,
  Tercero,
} from "../../types";

const setTipo = createAction(
  "SET_TIPO_CARGA_SINIESTRO",
  (tipoSelected: FieldChangeEvent<string | null>) => ({
    tipoSelected: aCampoSiniestro(tipoSelected),
  })
);

const setCompania = createAction(
  "SET_COMPANIA_CARGA_SINIESTRO",
  (companiaSelected: FieldChangeEvent<string | null>) => ({
    companiaSelected: aCampoSiniestro(companiaSelected),
  })
);

const setNumeroSiniestroCompania = createAction(
  "SET_NUMERO_SINIESTRO_COMPANIA_CARGA_SINIESTRO",
  (numeroSiniestroCompaniaSelected: FieldChangeEvent<string | null>) => ({
    numeroSiniestroCompaniaSelected: aCampoSiniestro(
      numeroSiniestroCompaniaSelected
    ),
  })
);

const setNumeroPoliza = createAction(
  "SET_NUMERO_POLIZA_CARGA_SINIESTRO",
  (numeroPolizaSelected: FieldChangeEvent<string | null>) => ({
    numeroPolizaSelected: aCampoSiniestro(numeroPolizaSelected),
  })
);

const setFecha = createAction(
  "SET_FECHA_CARGA_SINIESTRO",
  (fechaSelected: FieldChangeEvent<string | Date | null>) => ({
    fechaSelected: aCampoFecha(fechaSelected),
  })
);

const setHora = createAction(
  "SET_HORA_CARGA_SINIESTRO",
  (horaSelected: FieldChangeEvent<string | null>) => ({
    horaSelected: aCampoSiniestro(horaSelected),
  })
);

const setDireccion = createAction(
  "SET_DIRECCION_CARGA_SINIESTRO",
  (direccionSelected: FieldChangeEvent<string | null>) => ({
    direccionSelected: aCampoSiniestro(direccionSelected),
  })
);

const setLocalidad = createAction(
  "SET_LOCALIDAD_CARGA_SINIESTRO",
  (localidadSelected: OpcionSiniestro) => ({
    localidadSelected,
  })
);

const setProvincia = createAction(
  "SET_PROVINCIA_CARGA_SINIESTRO",
  (provinciaSelected: OpcionSiniestro) => ({
    provinciaSelected,
  })
);

const setCodigoPostal = createAction(
  "SET_CODIGO_POSTAL_CARGA_SINIESTRO",
  (codigoPostalSelected: OpcionSiniestro) => ({
    codigoPostalSelected,
  })
);

const setLesionesFisicas = createAction(
  "SET_LESIONES_FISICAS_CARGA_SINIESTRO",
  (lesionesFisicasSelected: FieldChangeEvent<string | null>) => ({
    lesionesFisicasSelected: aCampoSiniestro(lesionesFisicasSelected),
  })
);

const setComoOcurrio = createAction(
  "SET_COMO_OCURRIO_CARGA_SINIESTRO",
  (comoOcurrioSelected: FieldChangeEvent<string | null>) => ({
    comoOcurrioSelected: aCampoSiniestro(comoOcurrioSelected),
  })
);

const setDaniosVehiculo = createAction(
  "SET_DANIOS_VEHICULO_CARGA_SINIESTRO",
  (daniosVehiculoSelected: FieldChangeEvent<string | null>) => ({
    daniosVehiculoSelected: aCampoSiniestro(daniosVehiculoSelected),
  })
);

const setNombreConductor = createAction(
  "SET_NOMBRE_CONDUCTOR_CARGA_SINIESTRO",
  (nombreConductorSelected: FieldChangeEvent<string | null>) => ({
    nombreConductorSelected: aCampoSiniestro(nombreConductorSelected),
  })
);

const setApellidoConductor = createAction(
  "SET_APELLIDO_CONDUCTOR_CARGA_SINIESTRO",
  (apellidoConductorSelected: FieldChangeEvent<string | null>) => ({
    apellidoConductorSelected: aCampoSiniestro(apellidoConductorSelected),
  })
);

const setNumeroDocumentoConductor = createAction(
  "SET_DNI_CONDUCTOR_CARGA_SINIESTRO",
  (numeroDocumentoConductorSelected: FieldChangeEvent<string | null>) => ({
    numeroDocumentoConductorSelected: aCampoSiniestro(
      numeroDocumentoConductorSelected
    ),
  })
);

const setDocumentos = createAction(
  "SET_DOCUMENTOS_CARGA_SINIESTRO",
  (documentosSelected: string[]) => ({
    documentosSelected,
  })
);

const setDominio = createAction(
  "SET_DOMINIO_CARGA_SINIESTRO",
  (dominioSelected: FieldChangeEvent<string | null>) => ({
    dominioSelected: aCampoSiniestro(dominioSelected),
  })
);

const setModeloAnio = createAction(
  "SET_MODELO_ANIO_CARGA_SINIESTRO",
  (modeloAnioSelected: FieldChangeEvent<string | null>) => ({
    modeloAnioSelected: aCampoSiniestro(modeloAnioSelected),
  })
);

const setMarca = createAction(
  "SET_MARCA_CARGA_SINIESTRO",
  (marcaSelected: FieldChangeEvent<string | null>) => ({
    marcaSelected: aCampoSiniestro(marcaSelected),
  })
);

const setModelo = createAction(
  "SET_MODELO_CARGA_SINIESTRO",
  (modeloSelected: FieldChangeEvent<string | null>) => ({
    modeloSelected: aCampoSiniestro(modeloSelected),
  })
);

const setNumeroDocumentoAsegurado = createAction(
  "SET_NUMERO_DOCUMENTO_ASEGURADO_CARGA_SINIESTRO",
  (numeroDocumentoAseguradoSelected: FieldChangeEvent<string | null>) => ({
    numeroDocumentoAseguradoSelected: aCampoSiniestro(
      numeroDocumentoAseguradoSelected
    ),
  })
);

const setNombreAsegurado = createAction(
  "SET_NOMBRE_ASEGURADO_CARGA_SINIESTRO",
  (nombreAseguradoSelected: FieldChangeEvent<string | null>) => ({
    nombreAseguradoSelected: aCampoSiniestro(nombreAseguradoSelected),
  })
);

const setMail = createAction(
  "SET_MAIL_CARGA_SINIESTRO",
  (mailSelected: FieldChangeEvent<string | null>) => ({
    mailSelected: aCampoSiniestro(mailSelected),
  })
);

const setTelefono = createAction(
  "SET_TELEFONO_CARGA_SINIESTRO",
  (telefonoSelected: FieldChangeEvent<string | null>) => ({
    telefonoSelected: aCampoSiniestro(telefonoSelected),
  })
);

/**
 * Comparte el tipo de acción con la carga pública, así que los dos reducers
 * guardan los terceros a la vez.
 */
const setTerceros = createAction(
  "SET_TERCEROS_CARGA_SINIESTRO",
  (terceros: Tercero[]) => ({
    terceros,
  })
);

const setDocumentosFileName = createAction(
  "SET_DOCS_SINIESTRO_FILENAME",
  (documentosFileNameSelected: string[]) => ({
    documentosFileNameSelected,
  })
);

const setIsProcessingDocumentos = createAction(
  "SET_PROCESSING_DOCUMENTOS_SINIESTRO",
  (isProcessingDocumentos: boolean) => ({
    isProcessingDocumentos,
  })
);

const setSubmitting = createAction(
  "SET_SUBMITTING_CARGA_SINIESTRO",
  (submitting: boolean) => ({
    submitting,
  })
);

const clearData = createAction("CLEAR_DATA_CARGA_SINIESTRO");

const clearLocalidad = createAction("CLEAR_LOCALIDAD_CARGA_SINIESTRO");

const postSiniestroInited = createAction("POST_SINIESTRO_INITED");

const postSiniestroCompleted = createAction("POST_SINIESTRO_COMPLETED");

const postSiniestroFailed = createAction(
  "POST_SINIESTRO_FAILED",
  (error: unknown) => ({
    error,
  })
);

const postSiniestro = (data: CargaSiniestroData) => {
  return async (
    dispatch: Dispatch,
    getState: GetState,
    services: ServicesCargaSiniestro
  ) => {
    try {
      dispatch(postSiniestroInited());

      await services.api.siniestros().postSiniestro(data);

      dispatch(postSiniestroCompleted());
    } catch (error) {
      console.error(error);
      dispatch(postSiniestroFailed(error));
    }
  };
};

const getPolizasInited = createAction("OBTENER_POLIZAS_SINIESTRO_INITED");

const getPolizasCompleted = createAction(
  "OBTENER_POLIZAS_SINIESTRO_COMPLETED",
  (response: PolizasBuscadas | null | undefined) => {
    const polizas = response != null ? response.polizas : [];

    return { polizas };
  }
);

const getPolizasFailed = createAction(
  "OBTENER_POLIZAS_SINIESTRO_FAILED",
  (error: unknown) => ({
    error,
  })
);

const getPolizas = ({
  skip,
  take,
  fechaDesde,
  fechaHasta,
  searchCriteria,
  negocio,
  estado,
  soloParaRenovar,
  compania,
}: GetPolizasCriteria) => {
  return async (
    dispatch: Dispatch,
    getState: GetState,
    services: ServicesCargaSiniestro
  ) => {
    try {
      dispatch(getPolizasInited());

      const data = {
        skip,
        take,
        riesgoId: "",
        fechaDesde: fechaDesde ?? undefined,
        fechaHasta: fechaHasta ?? undefined,
        searchCriteria: searchCriteria ?? "",
        estado: estado ?? "",
        negocio: negocio ?? "",
        soloParaRenovar: soloParaRenovar ?? false,
        compania: compania ?? "",
      };

      const response = await services.api.polizas().getPolizas(data);

      dispatch(getPolizasCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(getPolizasFailed(error));
    }
  };
};

const getPolizaInited = createAction("OBTENER_POLIZA_SINIESTRO_INITED");

const getPolizaCompleted = createAction(
  "OBTENER_POLIZA_SINIESTRO_COMPLETED",
  (polizaVinculada: PolizaVinculada) => ({ polizaVinculada })
);

const getPolizaFailed = createAction(
  "OBTENER_POLIZA_SINIESTRO_FAILED",
  (error: unknown) => ({
    error,
  })
);

const getPoliza = (id: string) => {
  return async (
    dispatch: Dispatch,
    getState: GetState,
    services: ServicesCargaSiniestro
  ) => {
    try {
      dispatch(getPolizaInited());

      const response = await services.api.polizas().getPoliza(id);

      dispatch(getPolizaCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(getPolizaFailed(error));
    }
  };
};

const fetchLocalidadesInited = createAction(
  "OBTENER_LOCALIDADES_SINIESTRO_INITED"
);

const fetchLocalidadesCompleted = createAction(
  "OBTENER_LOCALIDADES_SINIESTRO_COMPLETED",
  (localidades: OpcionSiniestro[]) => ({ localidades })
);

const fetchLocalidadesFailed = createAction(
  "OBTENER_LOCALIDADES_SINIESTRO_FAILED",
  (error: unknown) => ({
    error,
  })
);

const fetchLocalidades = (provinciaId: string | number) => {
  return async (
    dispatch: Dispatch,
    getState: GetState,
    services: ServicesCargaSiniestro
  ) => {
    try {
      dispatch(fetchLocalidadesInited());
      const response = await services.api
        .provincias()
        .getLocalidades(String(provinciaId));

      const localidades = response.localidades
        .filter((v, i) => response.localidades.indexOf(v) === i)
        .filter((i) => i !== "")
        .map((item) => ({
          value: item,
          label: item,
        }));
      dispatch(fetchLocalidadesCompleted(localidades));
    } catch (error) {
      console.error(error);
      dispatch(fetchLocalidadesFailed(error));
    }
  };
};

const fetchCodigosPostalesInited = createAction("OBTENER_CP_SINIESTRO_INITED");

const fetchCodigosPostalesCompleted = createAction(
  "OBTENER_CP_SINIESTRO_COMPLETED",
  (codigosPostales: string[]) => ({ codigosPostales })
);

const fetchCodigosPostalesFailed = createAction(
  "OBTENER_CP_SINIESTRO_FAILED",
  (error: unknown) => ({
    error,
  })
);

const fetchCodigosPostales = (
  provinciaId: string | number,
  localidad: string
) => {
  return async (
    dispatch: Dispatch,
    getState: GetState,
    services: ServicesCargaSiniestro
  ) => {
    try {
      dispatch(fetchCodigosPostalesInited());
      const response = await services.api
        .provincias()
        .getCodigosPostales(String(provinciaId), localidad);
      dispatch(fetchCodigosPostalesCompleted(response.codigosPostales));
    } catch (error) {
      console.error(error);
      dispatch(fetchCodigosPostalesFailed(error));
    }
  };
};

const cargaSiniestroReducerInitialState: CargaSiniestroState = {
  tipoSelected: { value: "", valid: false, focus: false },
  companiaSelected: { value: "", valid: false, focus: false },
  numeroSiniestroCompaniaSelected: { value: "", valid: false, focus: false },
  numeroPolizaSelected: { value: "", valid: false, focus: false },
  idPolizaSelected: { value: "", valid: false, focus: false },
  sucursalSelected: { value: "", valid: false, focus: false },
  oficinaIdSelected: { value: "", valid: false, focus: false },
  fechaSelected: { value: null, valid: true, focus: false },
  horaSelected: { value: "", valid: false, focus: false },
  direccionSelected: { value: "", valid: false, focus: false },
  localidadSelected: { value: "", valid: false, focus: false },
  provinciaSelected: { value: "", valid: false, focus: false },
  codigoPostalSelected: { value: "", valid: false, focus: false },
  lesionesFisicasSelected: { value: "", valid: false, focus: false },
  comoOcurrioSelected: { value: "", valid: false, focus: false },
  daniosVehiculoSelected: { value: "", valid: false, focus: false },
  nombreConductorSelected: { value: "", valid: false, focus: false },
  apellidoConductorSelected: { value: "", valid: false, focus: false },
  numeroDocumentoConductorSelected: { value: "", valid: false, focus: false },
  dominioSelected: { value: "", valid: false, focus: false },
  modeloAnioSelected: { value: "", valid: false, focus: false },
  marcaSelected: { value: "", valid: false, focus: false },
  modeloSelected: { value: "", valid: false, focus: false },
  terceros: [],
  numeroDocumentoAseguradoSelected: { value: "", valid: false, focus: false },
  nombreAseguradoSelected: { value: "", valid: false, focus: false },
  mailSelected: { value: "", valid: false, focus: false },
  telefonoSelected: { value: "", valid: false, focus: false },
  documentosSelected: [],
  localidades: [],
  codigosPostales: [],
  polizaVinculada: null,
  polizasFilter: [],
  submitting: false,
  isLoading: false,
  isLoadingPoliza: false,
  creatingSiniestro: false,
  siniestroCreado: false,
  isProcessingDocumentos: false,
};

const cargaSiniestroReducer = handleActions<CargaSiniestroState, any>(
  {
    [setTipo.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ tipoSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      const tipoSelected = {
        ...action.payload.tipoSelected,
        valid: action.payload.tipoSelected.value !== "",
        focus: action.payload.tipoSelected.value === "",
      };
      return {
        ...state,
        tipoSelected: tipoSelected,
      };
    },
    [setCompania.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ companiaSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        companiaSelected: action.payload.companiaSelected,
      };
    },
    [setNumeroSiniestroCompania.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ numeroSiniestroCompaniaSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        numeroSiniestroCompaniaSelected:
          action.payload.numeroSiniestroCompaniaSelected,
      };
    },
    [setNumeroPoliza.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ numeroPolizaSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        numeroPolizaSelected: action.payload.numeroPolizaSelected,
      };
    },
    [setFecha.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ fechaSelected: CampoFecha }>
    ): CargaSiniestroState => {
      return {
        ...state,
        fechaSelected: action.payload.fechaSelected,
      };
    },
    [setHora.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ horaSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        horaSelected: action.payload.horaSelected,
      };
    },
    [setDireccion.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ direccionSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        direccionSelected: action.payload.direccionSelected,
      };
    },
    [setLocalidad.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ localidadSelected: OpcionSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        localidadSelected: {
          value: action.payload.localidadSelected.label,
          valid: true,
          focus: false,
        },
      };
    },
    [setProvincia.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ provinciaSelected: OpcionSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        provinciaSelected: {
          value: action.payload.provinciaSelected.label,
          valid: true,
          focus: false,
          searchId: action.payload.provinciaSelected.value ?? undefined,
        },
      };
    },
    [setCodigoPostal.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ codigoPostalSelected: OpcionSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        codigoPostalSelected: {
          value: action.payload.codigoPostalSelected.label,
          valid: true,
          focus: false,
        },
      };
    },
    [setLesionesFisicas.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ lesionesFisicasSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        lesionesFisicasSelected: action.payload.lesionesFisicasSelected,
      };
    },
    [setComoOcurrio.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ comoOcurrioSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        comoOcurrioSelected: action.payload.comoOcurrioSelected,
      };
    },
    [setDaniosVehiculo.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ daniosVehiculoSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        daniosVehiculoSelected: action.payload.daniosVehiculoSelected,
      };
    },
    [setNombreConductor.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ nombreConductorSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        nombreConductorSelected: action.payload.nombreConductorSelected,
      };
    },
    [setApellidoConductor.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ apellidoConductorSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        apellidoConductorSelected: action.payload.apellidoConductorSelected,
      };
    },
    [setNumeroDocumentoConductor.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ numeroDocumentoConductorSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        numeroDocumentoConductorSelected:
          action.payload.numeroDocumentoConductorSelected,
      };
    },
    [setDominio.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ dominioSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        dominioSelected: action.payload.dominioSelected,
      };
    },
    [setModeloAnio.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ modeloAnioSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        modeloAnioSelected: action.payload.modeloAnioSelected,
      };
    },
    [setMarca.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ marcaSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        marcaSelected: action.payload.marcaSelected,
      };
    },
    [setModelo.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ modeloSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        modeloSelected: action.payload.modeloSelected,
      };
    },
    [setNumeroDocumentoAsegurado.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ numeroDocumentoAseguradoSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        numeroDocumentoAseguradoSelected:
          action.payload.numeroDocumentoAseguradoSelected,
      };
    },
    [setTerceros.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ terceros: Tercero[] }>
    ): CargaSiniestroState => {
      return {
        ...state,
        terceros: action.payload.terceros,
      };
    },
    [setNombreAsegurado.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ nombreAseguradoSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        nombreAseguradoSelected: action.payload.nombreAseguradoSelected,
      };
    },
    [setMail.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ mailSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        mailSelected: action.payload.mailSelected,
      };
    },
    [setTelefono.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ telefonoSelected: CampoSiniestro }>
    ): CargaSiniestroState => {
      return {
        ...state,
        telefonoSelected: action.payload.telefonoSelected,
      };
    },
    [setDocumentosFileName.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ documentosFileNameSelected: string[] }>
    ): CargaSiniestroState => {
      return {
        ...state,
        documentosSelected: action.payload.documentosFileNameSelected,
      };
    },
    [setIsProcessingDocumentos.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ isProcessingDocumentos: boolean }>
    ): CargaSiniestroState => {
      return {
        ...state,
        isProcessingDocumentos: action.payload.isProcessingDocumentos,
      };
    },
    [setSubmitting.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ submitting: boolean }>
    ): CargaSiniestroState => {
      return {
        ...state,
        submitting: action.payload.submitting,
      };
    },
    [postSiniestroInited.toString()]: (
      state: CargaSiniestroState
    ): CargaSiniestroState => {
      return {
        ...state,
        isLoading: true,
        creatingSiniestro: true,
      };
    },
    [postSiniestroCompleted.toString()]: (
      state: CargaSiniestroState
    ): CargaSiniestroState => {
      return {
        ...state,
        siniestroCreado: true,
        isLoading: false,
        creatingSiniestro: false,
      };
    },
    [postSiniestroFailed.toString()]: (
      state: CargaSiniestroState
    ): CargaSiniestroState => {
      return {
        ...state,
        isLoading: false,
        creatingSiniestro: false,
      };
    },
    [getPolizasInited.toString()]: (
      state: CargaSiniestroState
    ): CargaSiniestroState => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [getPolizasCompleted.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ polizas: PolizasBuscadas["polizas"] }>
    ): CargaSiniestroState => {
      const polizasFilter = action.payload.polizas.map((poliza) => ({
        label: `${poliza.marca} ${poliza.modelo} ${poliza.dominio} ${poliza.estado}`,
        value: poliza.id,
      }));

      return {
        ...state,
        polizasFilter: polizasFilter,
        isLoading: false,
        failed: false,
        reloadPolizas: false,
      };
    },
    [getPolizasFailed.toString()]: (
      state: CargaSiniestroState
    ): CargaSiniestroState => {
      return {
        ...state,
        isLoading: false,
        failed: true,
        reloadPolizas: false,
      };
    },
    [getPolizaInited.toString()]: (
      state: CargaSiniestroState
    ): CargaSiniestroState => {
      return {
        ...state,
        isLoading: true,
      };
    },
    [getPolizaCompleted.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ polizaVinculada: PolizaVinculada }>
    ): CargaSiniestroState => {
      const { polizaVinculada } = action.payload;
      const { asegurado, datosVehiculo, datosPlan } = polizaVinculada;

      return {
        ...state,
        polizaVinculada: polizaVinculada,
        isLoading: false,
        failed: false,
        nombreAseguradoSelected: {
          value: asegurado?.nombreCompleto ?? "",
          valid: true,
          focus: false,
        },
        idPolizaSelected: {
          value: polizaVinculada.id,
          valid: true,
          focus: false,
        },
        sucursalSelected: {
          value: polizaVinculada.sucursalNombre ?? "",
          valid: true,
          focus: false,
        },
        oficinaIdSelected: {
          value: polizaVinculada.oficinaId,
          valid: true,
          focus: false,
        },
        numeroDocumentoAseguradoSelected: {
          value: asegurado?.numeroDocumento ?? "",
          valid: true,
          focus: false,
        },
        mailSelected: {
          value: asegurado?.email ? asegurado.email : "",
          valid: true,
          focus: false,
        },
        telefonoSelected: {
          value: asegurado?.telefonoCelular
            ? asegurado.telefonoCelular
            : asegurado?.telefonoFijo
              ? asegurado.telefonoFijo
              : "",
          valid: true,
          focus: false,
        },
        dominioSelected: {
          value: datosVehiculo?.dominio ?? "",
          valid: true,
          focus: false,
        },
        modeloAnioSelected: {
          value: String(datosVehiculo?.anio ?? ""),
          valid: true,
          focus: false,
        },
        marcaSelected: {
          value: datosVehiculo?.marca ?? "",
          valid: true,
          focus: false,
        },
        modeloSelected: {
          value: datosVehiculo?.modelo ?? "",
          valid: true,
          focus: false,
        },
        numeroPolizaSelected: {
          value: datosPlan?.numeroPoliza ?? "",
          valid: true,
          focus: false,
        },
        companiaSelected: {
          value: datosPlan?.compania ?? "",
          valid: true,
          focus: false,
        },
      };
    },
    [getPolizaFailed.toString()]: (
      state: CargaSiniestroState
    ): CargaSiniestroState => {
      return {
        ...state,
        isLoading: false,
        failed: true,
      };
    },
    [fetchLocalidadesInited.toString()]: (
      state: CargaSiniestroState
    ): CargaSiniestroState => {
      return {
        ...state,
      };
    },
    [fetchLocalidadesCompleted.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ localidades: OpcionSiniestro[] }>
    ): CargaSiniestroState => {
      return {
        ...state,
        localidades: action.payload.localidades,
        localidadSelected: {
          value: action.payload.localidades[0].label,
          valid: true,
          focus: false,
        },
      };
    },
    [fetchLocalidadesFailed.toString()]: (
      state: CargaSiniestroState
    ): CargaSiniestroState => {
      return {
        ...state,
      };
    },
    [fetchCodigosPostalesInited.toString()]: (
      state: CargaSiniestroState
    ): CargaSiniestroState => {
      return {
        ...state,
      };
    },
    [fetchCodigosPostalesCompleted.toString()]: (
      state: CargaSiniestroState,
      action: Action<{ codigosPostales: string[] }>
    ): CargaSiniestroState => {
      const codigosPostales = action.payload.codigosPostales.map((item) => ({
        value: item,
        label: item,
      }));
      return {
        ...state,
        codigosPostales: codigosPostales,
      };
    },
    [fetchCodigosPostalesFailed.toString()]: (
      state: CargaSiniestroState
    ): CargaSiniestroState => {
      return {
        ...state,
      };
    },
    [clearLocalidad.toString()]: (
      state: CargaSiniestroState
    ): CargaSiniestroState => {
      return {
        ...state,
        localidadSelected: {
          value: "",
          valid: false,
          focus: false,
        },
      };
    },
    [clearData.toString()]: (): CargaSiniestroState => {
      return {
        ...cargaSiniestroReducerInitialState,
      };
    },
  },
  cargaSiniestroReducerInitialState
);

export { cargaSiniestroReducer };

export {
  clearData,
  clearLocalidad,
  setSubmitting,
  postSiniestro,
  setTipo,
  setCompania,
  setNumeroSiniestroCompania,
  setNumeroPoliza,
  setDireccion,
  setHora,
  setFecha,
  setLocalidad,
  setProvincia,
  setCodigoPostal,
  setLesionesFisicas,
  setComoOcurrio,
  setDaniosVehiculo,
  setNombreConductor,
  setApellidoConductor,
  setNumeroDocumentoConductor,
  setDominio,
  setModeloAnio,
  setMarca,
  setModelo,
  setNumeroDocumentoAsegurado,
  setNombreAsegurado,
  setMail,
  setTelefono,
  setTerceros,
  setDocumentos,
  setDocumentosFileName,
  setIsProcessingDocumentos,
  getPolizas,
  getPoliza,
  fetchCodigosPostales,
  fetchLocalidades,
};
